import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _CREATE_HTTP_INSTANCE;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { EMPTY_OBJECT } from 'tbase/app.constants';
import createHTTP from './withInterceptor';
import HTTPClient from '../../utils/httpClient';
import { URL_TYPES_VS_HEADERS, getCdmsUrl, getTdpUrl, getDseUrl, getCacheParams, getMediaUrl, cloudDataURL, getStandaloneUrl } from './apiService.helper';
import { URL_TYPES } from '../../constants/api';
var instance = {};
export var getCurrentHTTPInstances = function getCurrentHTTPInstances() {
  return instance;
};

var createCdmsHttpInstance = function createCdmsHttpInstance() {
  var cdmsHttpInstance = new Http(URL_TYPES.CDMS, {
    url: "".concat(getCdmsUrl(), "/")
  });
  return cdmsHttpInstance;
};

var createDseHttpInstance = function createDseHttpInstance() {
  var dseHttpInstance = new Http(URL_TYPES.DSE, {
    url: "".concat(getDseUrl(), "/")
  });
  return dseHttpInstance;
};

var createTdpHttpInstance = function createTdpHttpInstance() {
  var tdpHttpInstance = new Http(URL_TYPES.TDP, {
    url: getTdpUrl()
  });
  return tdpHttpInstance;
};

var createMediaHttpInstance = function createMediaHttpInstance() {
  var mediaHttpInstance = new Http(URL_TYPES.MEDIA, {
    url: getMediaUrl()
  });
  return mediaHttpInstance;
};

var creteTekionDataURLInstance = function creteTekionDataURLInstance() {
  var cloudHttpInstance = new Http(URL_TYPES.DATA, {
    url: cloudDataURL()
  });
  return cloudHttpInstance;
};

var createStandaloneHttpInstance = function createStandaloneHttpInstance() {
  var standaloneHttpInstance = new Http(URL_TYPES.STANDALONE, {
    url: getStandaloneUrl()
  });
  return standaloneHttpInstance;
};

export var setDefaultModuleServices = function setDefaultModuleServices() {
  var CdmsClient = createCdmsHttpInstance(); // eslint-disable-line

  var DmsClient = createDseHttpInstance(); // eslint-disable-line

  var tdpClient = createTdpHttpInstance(); // eslint-disable-line

  var mediaClient = createMediaHttpInstance(); // eslint-disable-line

  var cloudClient = creteTekionDataURLInstance(); // eslint-disable-line

  var standaloneClient = createStandaloneHttpInstance(); // eslint-disable-line
};
export var removeDefaultModuleServices = function removeDefaultModuleServices() {
  instance = {};
};

var getHeaders = function getHeaders(moduleType) {
  var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT;
  var getHeaderFunc = URL_TYPES_VS_HEADERS[moduleType] || URL_TYPES_VS_HEADERS.CDMS;
  return _objectSpread(_objectSpread({}, getHeaderFunc()), headers);
};

var CREATE_HTTP_INSTANCE_BY_MODULE_TYPE = (_CREATE_HTTP_INSTANCE = {}, _defineProperty(_CREATE_HTTP_INSTANCE, URL_TYPES.CDMS, createCdmsHttpInstance), _defineProperty(_CREATE_HTTP_INSTANCE, URL_TYPES.DSE, createDseHttpInstance), _defineProperty(_CREATE_HTTP_INSTANCE, URL_TYPES.TDP, createTdpHttpInstance), _defineProperty(_CREATE_HTTP_INSTANCE, URL_TYPES.MEDIA, createMediaHttpInstance), _defineProperty(_CREATE_HTTP_INSTANCE, URL_TYPES.DATA, creteTekionDataURLInstance), _defineProperty(_CREATE_HTTP_INSTANCE, URL_TYPES.STANDALONE, createStandaloneHttpInstance), _CREATE_HTTP_INSTANCE);
export var getHttpInstance = function getHttpInstance(moduleType) {
  var cachedHttpInstanceForModuleType = instance[moduleType];

  if (cachedHttpInstanceForModuleType) {
    return cachedHttpInstanceForModuleType;
  }

  var createHttpInstanceForModuleType = CREATE_HTTP_INSTANCE_BY_MODULE_TYPE[moduleType];
  createHttpInstanceForModuleType();
  var httpInstance = instance[moduleType];
  return httpInstance;
};

var Http = /*#__PURE__*/function () {
  function Http(moduleType) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_OBJECT,
        url = _ref.url,
        headers = _ref.headers;

    _classCallCheck(this, Http);

    instance[moduleType] = createHTTP(url, _objectSpread({}, headers));
  }

  _createClass(Http, null, [{
    key: "get",
    value: function get(moduleType, url, data, headers, additional) {
      var httpInstance = getHttpInstance(moduleType);
      return httpInstance({
        method: 'GET',
        cache: getCacheParams(additional),
        headers: _objectSpread({}, getHeaders(moduleType, headers)),
        url: url,
        params: data
      });
    }
  }, {
    key: "post",
    value: function post(moduleType, url, data, query, headers, additional) {
      var httpInstance = getHttpInstance(moduleType);
      return httpInstance({
        method: 'POST',
        cache: getCacheParams(additional),
        headers: _objectSpread({}, getHeaders(moduleType, headers)),
        url: url,
        data: data,
        params: query
      });
    }
  }, {
    key: "put",
    value: function put(moduleType, url, data, query, headers, additional) {
      var httpInstance = getHttpInstance(moduleType);
      return httpInstance({
        method: 'PUT',
        cache: getCacheParams(additional),
        headers: _objectSpread({}, getHeaders(moduleType, headers)),
        url: url,
        data: data,
        params: query
      });
    }
  }, {
    key: "patch",
    value: function patch(moduleType, url, data, query, headers, additional) {
      var httpInstance = getHttpInstance(moduleType);
      return httpInstance({
        method: 'PATCH',
        cache: getCacheParams(additional),
        headers: _objectSpread({}, getHeaders(moduleType, headers)),
        url: url,
        data: data,
        params: query
      });
    }
  }, {
    key: "delete",
    value: function _delete(moduleType, url, data, query, headers, additional) {
      var httpInstance = getHttpInstance(moduleType);
      return httpInstance({
        method: 'DELETE',
        cache: getCacheParams(additional),
        headers: _objectSpread({}, getHeaders(moduleType, headers)),
        url: url,
        data: data,
        params: query
      });
    }
  }]);

  return Http;
}();

var init = function init() {
  HTTPClient.getInstance().interceptors.response.use(function (response) {
    return response.data;
  });
};

init();
export default Http;